import React, { Component } from "react";
import ProductSuggestion from "./ProductSuggestion.jsx";
import "./ProductSuggestions.scss";
import shortProductId from "../../common/helpers/shortId.js";

class ProductSuggestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      productSuggestions: {},
    };
  }

  async componentDidMount() {
    this.props.store.getCombinationProductRules();
    await this.checkSuggestions();
    await this.removeDuplicateSugestions();
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.articles !== this.props.articles) {
      await this.setState({ suggestions: [], productSuggestions: {} });
      console.log("da new articles are", this.props.articles);
      await this.checkSuggestions();
      await this.removeDuplicateSugestions();
    }
  }
  async getShortIdsFromBasket() {
    return await this.props.articles.map((a) => shortProductId(a));
  }

  async checkSuggestions() {
    // On recup un array avec seulement les ids des produits qui sont dans le panier
    const basket = await this.getShortIdsFromBasket();
    console.log("basket", basket);
    // pour ensuite filtrer le fichier de suggestions, et ne garder que celles qui concernent les produits
    // que l'on a dans le panier
    let articlesWithSuggestions = [];
    await this.props.store.combinationProductRules.products.map(async (p) => {
      console.log("ppp", p.id);
      if (basket.includes(p.id)) {
        articlesWithSuggestions.push(p);
      }
      // return await basket.includes(p.id);
    });

    console.log(
      "articles with suggestions for current basket",
      articlesWithSuggestions
    );

    const productSuggestions = {};
    const getSuggestionsOfSingleProduct = async (product) => {
      // On verifie que tous les produits listes dans combinedWith de CHAQUE suggestion sont presents dans le panier
      // et on garde la suggestion si c'est le cas
      await product.suggestions.map(async (s) => {
        const isSuggestionMatching = await s.combinedWith.every((i) => {
          return basket.includes(i);
        });
        if (isSuggestionMatching) {
          console.log("sugg matching", product);

          // On cree un tableau vide si avant de pusher une suggestion
          if (!productSuggestions[product.id])
            productSuggestions[product.id] = [];

          await productSuggestions[product.id].push({
            ruleOnProduct: product.id,
            relatedProducts: s.combinedWith,
            suggestions: s.suggests,
          });
        }
      });
    };

    await articlesWithSuggestions.map(
      async (pro) => await getSuggestionsOfSingleProduct(pro)
    );

    console.log("product SUggestions", productSuggestions);
    await this.setState({
      productSuggestions: productSuggestions,
    });
  }
  async removeDuplicateSugestions() {
    console.log(
      "will remove duplicate suggestions",
      this.state.productSuggestions
    );
    // Pour chaque produit, on ne garde que la suggestion qui compte le plus de produits cumulés
    const suggestions = [];
    await Object.keys(this.state.productSuggestions).map(async (key, index) => {
      const singleSuggestion = await this.state.productSuggestions[
        key
      ].reduce((count, sugg) =>
        count.relatedProducts.length > sugg.relatedProducts.length
          ? count
          : sugg
      );
      suggestions.push(singleSuggestion);
    });

    // On refait un filtrage pour garder que les suggestions où il ya le plus de produits cumulés
    // mais cette fois sur l'ensemble des suggestions, par seulement sur les suggestions par produit
    // Ex: Suggestion 1 : [E, F] Suggestion 2 : [E+D+F], on veut que suggestion 2
    const filteredSuggestions = suggestions.reduce((count, sugg) =>
      count.relatedProducts.length > sugg.relatedProducts.length ? count : sugg
    );

    this.setState({ suggestions: [filteredSuggestions] });
  }

  render() {
    const { suggestions } = this.state;
    const { store } = this.props;

    return (
      <div className="product-suggestions">
        {suggestions.map((s, i) => (
          <ProductSuggestion
            key={i}
            suggestion={s}
            store={store}
            articles={this.props.articles}
            willRefreshCart={this.props.willRefreshCart}
            refreshCart={this.props.refreshCart.bind(this)}
          />
        ))}
      </div>
    );
  }
}

export default ProductSuggestions;
